export enum WORD_STATUS {
    PENDING = 'pending',
    VALIDATING = 'validating',
    REJECT = 'reject',
    READY = 'ready',
}